//******************************************************************************
// import
import { SimpleMeshLayer } from "@deck.gl/mesh-layers";
import { SphereGeometry } from "@luma.gl/engine";
import { adjustBrightness } from "../optimizeColor/adjustBrightness";
import { getPickedVertex } from "../getPickingVertex/getPickingVertex";

//******************************************************************************
// レイヤIDを決めるためのプレフィックスと値生成関数
const getKey = () => {
	return `select_${Date.now() + Math.random()}`;
};

//******************************************************************************
// export class
export class OnMousePoint {
	//**************************************************************************
	/**
	 * コンストラクタ
	 * @param {{radius:number}} opts
	*/
	constructor(opts) {
		//----------------------------------------------------------------------
		// 引数をメンバ変数に格納する
		this.opts = opts;
		//----------------------------------------------------------------------
		// optsを整理する
		const options = {
			radius: opts.radius ?? 5
		};
		//----------------------------------------------------------------------
		// propsを構築する
		const props = {
			id: getKey(),
			data: [],
			getPosition: d => d.coordinates,
			getColor: [0, 0, 0],
			pickable: false,
			// material: false,
			mesh: new SphereGeometry({ radius: options.radius }),
		};
		//----------------------------------------------------------------------
		// レイヤを生成してメンバ変数に格納する
		this.layer = new SimpleMeshLayer(props);
	}

	//**************************************************************************
	/**
	 * 球のハイライト処理
	 * @param {Object} [picking]
	 * @returns {this}
	*/
	highlight(picking) {
		//----------------------------------------------------------------------
		// propsを取得する
		const props = this.restoreProps();
		//----------------------------------------------------------------------
		// 引数で分岐
		if (
			typeof picking === "undefined"
			|| picking === null
			|| picking.picked === false
		) {
			// 条件に合致しない場合はハイライト球を空にする
			props.data = [];
		} else {
			// 条件に合致した場合
			// 頂点情報を取得
			const vertex = getPickedVertex(picking);
			if (vertex !== null) {
				// ハイライト球を与える
				props.data = [{ coordinates: vertex.coordinates }];
				// 色を目立たせるため若干輝度を上げて設定
				const color = adjustBrightness(vertex.color, 0.05);
				props.getColor = color;
			}
		}
		//----------------------------------------------------------------------
		// レイヤを生成してメンバ変数に格納する
		this.layer = new SimpleMeshLayer(props);
		//----------------------------------------------------------------------
		// 参照を返す
		return this;
	}

	//**************************************************************************
	/**
	 * 現状のpropsを復元して返す
	 * @returns {Object}
	*/
	restoreProps() {
		//----------------------------------------------------------------------
		// 現状のpropsを取得して新しいpropsを作る
		const props = Object.fromEntries(
			Object.entries(this.layer.props)
		);
		//----------------------------------------------------------------------
		// idを更新しないと新しいデータで描画してくれない
		props.id = getKey();
		//----------------------------------------------------------------------
		// dataとmeshはgetterになっているのであらためてここで取得しておく
		props.mesh = this.layer.props.mesh;
		//----------------------------------------------------------------------
		// 復元したpropsを返す
		return props;
	}

	//**************************************************************************
	/**
	 * レイヤを取得
	 * @returns {Object}
	*/
	getLayer() {
		//----------------------------------------------------------------------
		// レイヤインスタンスを返す
		return this.layer;
	}

	//**************************************************************************
	/**
	 * 球のサイズを調整する
	 * @param {number} scale
	 * @returns {this}
	*/
	scaleUpdate(scale) {
		//----------------------------------------------------------------------
		// 現状のpropsを取得して新しいpropsを作る
		const props = this.restoreProps();
		props.getScale = () => {
			return [scale, scale, scale];
		};
		this.layer = new this.layer.constructor(props);
		//----------------------------------------------------------------------
		// 参照を返す
		return this;
	}

	//**************************************************************************
	/**
	 * レイヤ名を取得
	 * @returns	{string}
	*/
	getName() {
		//----------------------------------------------------------------------
		// レイヤのコンストラクタ名を返す
		return this.layer.constructor.name;
	}

	//**************************************************************************
	/**
	 * 登録中の球数を返す
	 * @returns {number}
	*/
	getCount() {
		//----------------------------------------------------------------------
		// データの長さ（=球の数）を返す
		return this.layer.props.data.length;
	}
};
